import React, { Component } from "react";
import FireBase from "firebase/app";
import Iframe from "react-iframe";
import "rc-color-picker/assets/index.css";
import ColorPicker from "rc-color-picker";
import uuid from "uuid/v1";
import TextField from "material-ui/TextField";
import LinearProgress from "../components/LinearProgress";
import Paper from "material-ui/Paper";
import { RaisedButton, Snackbar } from "material-ui";
import FileUpload from "../components/FileUpload";
import firebase from "../firebase";
import { injectStripe, CardElement } from "react-stripe-elements";
import StripeElements from "../components/StripeElements";
import { browserHistory } from "react-router";
import LinkWithStripe from "../components/LinkWithStripe";
import URLQrCode from "../components/URLQrCode";

const styles = {
  root: {
    padding: 20,
    margin: "0 auto",
  },
  form: {},
  toggleStyle: {
    marginTop: 10,
    marginBottom: 10,
  },
  paper: {
    padding: 20,
  },
  gridList: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
  },
  saveButton: {
    marginTop: 15,
  },
};

class Settings extends Component {
  state = {
    mutable: {
      name: "",
      active: true,
      photo: "",
      website: "",
      email: "",
      facebook: "",
      color: "#EAEAEA",
      primaryColor: "#EAEAEA",
      instagram: "",
      twitter: "",
      snapchat: "",
      settings: {
        productsLayout: 0,
        categoriesLayout: 0,
      },
      stripe_account: null,
      webAppUrl: null,
    },
    submitting: false,
    uploadProgress: 0,
    uploading: false,
    productId: null,
    loading: true,
    snackbarOpen: false,
    snackbarMessage: "",
  };

  // redirectToPayments = () => {
  //   browserHistory.push(`/subscribe`);
  // };

  async componentDidMount() {
    const { params, create } = this.props;

    if (!create) {
      const restaurantId = params && params.restaurantId;
      this.restaurantPath = firebase
        .firestore()
        .collection("restaurant")
        .doc(restaurantId);

      try {
        const restaurantSnap = await this.restaurantPath.get();

        const restaurant = restaurantSnap.data();

        this.setState({
          mutable: restaurant,
          restaurantId,
          native: !!restaurant.subscription,
          loading: false,
        });
      } catch (e) {
        console.log({ e });
        this.setState({
          loading: false,
        });
      }
    } else {
      // const subscriptions = await firebase
      //   .firestore()
      //   .collection("users")
      //   .doc(firebase.auth().currentUser.uid)
      //   .collection("subscriptions")
      //   .get();
      // if (subscriptions.docs.length == 0) {
      //   return this.redirectToPayments();
      // }
      // let subscription = subscriptions.docs.find((it) => !it.data.restaurant);
      // if (subscription) {
      this.setState({
        loading: false,
        // subscription: subscription && subscription.id,
        native: false,
      });
      // } else {
      // this.redirectToPayments();
      // }
    }
  }

  handleSubmit = async () => {
    this.setState({
      submitting: true,
    });

    const restaurant = this.state.mutable;

    if (this.props.create) {
      // create new restaurant
      const userId = firebase.auth().currentUser.uid;
      restaurant["staff"] = {};
      restaurant["staff"][userId] = true;
      // if (subscription) restaurant.subscription = subscription;

      try {
        const restaurantSnap = await firebase
          .firestore()
          .collection("restaurant")
          .add(restaurant);
        this.setState({
          submitting: false,
          snackbarOpen: true,
          snackbarMessage: "Changes Saved",
        });

        this.props.onCreated && this.props.onCreated(restaurantSnap.id);
        browserHistory.push(`/${restaurantSnap.id}`);
      } catch (e) {
        console.error(e.message);
        this.setState({
          submitting: false,
          snackbarOpen: true,
          snackbarMessage: "Error Creating",
        });
      }
    } else {
      try {
        await this.restaurantPath.update(restaurant);
        this.setState({
          submitting: false,
          snackbarOpen: true,
          snackbarMessage: "Changes Saved",
        });
      } catch (e) {
        console.error(e);
        this.setState({
          submitting: false,
          snackbarOpen: true,
          snackbarMessage: "Unexpected error",
        });
      }
    }
  };

  handleImageDrop = (accepted, reject) => {
    const { restaurantId } = this.state;
    const file = accepted[0];
    const metadata = {
      contentType: file.type,
    };

    const uploadTask = firebase
      .storage()
      .ref(`/restaurants/${restaurantId}/${uuid()}${file.name}`)
      .put(file, metadata);

    uploadTask.on(
      FireBase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        this.setState({
          uploadProgress: progress,
          uploading: true,
        });
      },
      (error) => {},
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          this.updateMutableField("photo", downloadURL);
          this.setState({
            uploading: false,
          });
        });
      }
    );
  };

  handleCloseSnackbar = () => {
    this.setState({
      snackbarOpen: false,
    });
  };

  // onProductLayoutChange = (productsLayout) => {
  //   this.setState({
  //     ...this.state,
  //     settings: {
  //       ...this.state.settings,
  //       productsLayout,
  //     },
  //   });
  // };

  // onCategoriesLayoutChange = (categoriesLayout) => {
  //   this.setState({
  //     ...this.state,
  //     settings: {
  //       ...this.state.settings,
  //       categoriesLayout,
  //     },
  //   });
  // };

  accentColorChangeHandler = ({ color }) => {
    this.updateMutableField("color", color);
  };

  primaryColorChangeHandler = ({ color }) => {
    this.updateMutableField("primaryColor", color);
  };

  render() {
    const { params } = this.props;
    const restaurantId = params && params.restaurantId;

    const { mutable, uploading, submitting, loading } = this.state;
    const {
      name,
      description,
      website,
      email,
      color,
      primaryColor,
      active,
      photo,
      settings,
      webAppUrl,
    } = mutable;

    const appPreviewUrl = `https://chowreach.web.app/?restaurantId=${restaurantId}`;
    const qrUrl = webAppUrl || appPreviewUrl;

    const { create } = this.props;

    if (loading) return <LinearProgress />;

    return (
      <div style={styles.root}>
        <h1>{create ? "Create Restaurant" : "Restaurant Settings"}</h1>
        <form style={styles.form}>
          <Paper style={styles.paper}>
            <TextField
              hintText="Enter restaurant name"
              value={name}
              required
              onChange={(e) => this.updateMutableField("name", e.target.value)}
              fullWidth
              floatingLabelText="Restaurant Name"
            />
            <TextField
              hintText="Enter a short description or tagline"
              value={description}
              required
              onChange={(e) =>
                this.updateMutableField("description", e.target.value)
              }
              fullWidth
              floatingLabelText="Description"
            />
            <TextField
              value={website}
              onChange={(e) =>
                this.updateMutableField("website", e.target.value)
              }
              fullWidth
              floatingLabelText="Website"
              hintText="https://restaurant.com"
            />
            <TextField
              value={email}
              onChange={(e) => this.updateMutableField("email", e.target.value)}
              fullWidth
              floatingLabelText="Email Address"
              hintText="restaurant@email.com"
            />
            <h3>Primary color</h3>
            <ColorPicker
              color={primaryColor}
              onChange={this.primaryColorChangeHandler}
              onClose={this.primaryColorChangeHandler}
              placement="topLeft"
              className="some-class"
              enableAlpha={false}
            >
              <span
                className="rc-color-picker-trigger"
                style={{ width: 50, height: 50 }}
              />
            </ColorPicker>
            <h3>Accent color</h3>
            <ColorPicker
              color={color}
              onChange={this.accentColorChangeHandler}
              onClose={this.accentColorChangeHandler}
              placement="topLeft"
              className="some-class"
              enableAlpha={false}
            >
              <span
                className="rc-color-picker-trigger"
                style={{ width: 50, height: 50 }}
              />
            </ColorPicker>

            {/* <Toggle
              label="Active"
              labelPosition="right"
              toggled={active}
              onToggle={(e, active) => this.setState({ active })}
              style={styles.toggleStyle}
            /> */}
          </Paper>
          {this.renderMenuQRSection()}

          {this.renderOnlineOrderingSection()}

          {this.renderSocialMediaLinksInput()}
          {/* <h2>App Layouts</h2>
          <Paper style={{ padding: 15, minHeight: 150 }}>
            <h3>Menu Categories</h3>
            <ImageRadioGroup
              name="categoriesLayout"
              selectedIndex={settings && settings.categoriesLayout}
              onIndexSelected={this.onCategoriesLayoutChange}
            >
              <ColumnIcon style={{ width: 100, height: 100 }} />
              <CardIcon style={{ width: 100, height: 100 }} />
              <SimpleListIcon style={{ width: 100, height: 100 }} />
            </ImageRadioGroup>
            <h3>Menu Products</h3>
            <ImageRadioGroup
              name="productsLayout"
              selectedIndex={settings && settings.productsLayout}
              onIndexSelected={this.onProductLayoutChange}
            >
              <ColumnIcon style={{ width: 100, height: 100 }} />
              <ListIcon style={{ width: 100, height: 100 }} />
            </ImageRadioGroup>
          </Paper> */}
          <h2>Logo</h2>
          <Paper style={{ padding: 15, display: "flex" }}>
            <FileUpload
              multiple={false}
              onDrop={this.handleImageDrop}
              accept="image/png, image/jpeg"
              uploadProgress={this.state.uploadProgress}
              uploading={this.state.uploading}
            />
            <img src={photo} style={{ height: 200, marginLeft: 20 }} />
          </Paper>
          <RaisedButton
            label="Save"
            style={styles.saveButton}
            onTouchTap={this.handleSubmit}
            secondary
            disabled={submitting || uploading}
          />
          <Snackbar
            open={this.state.snackbarOpen}
            message={this.state.snackbarMessage}
            autoHideDuration={4000}
            onRequestClose={this.handleCloseSnackbar}
          />
        </form>
      </div>
    );
  }

  updateMutableField(fieldName, value) {
    const mutable = this.state.mutable;
    mutable[fieldName] = value;
    this.setState({
      mutable,
    });
  }

  renderSocialMediaLinksInput() {
    const { native, mutable } = this.state;
    const { facebook, instagram, twitter, snapchat } = mutable;
    if (!native) return <div />;
    return (
      <div>
        <h2>Social Media Links</h2>
        <Paper style={{ padding: 15 }}>
          <TextField
            value={facebook}
            onChange={(e) =>
              this.updateMutableField("facebook", e.target.value)
            }
            fullWidth
            floatingLabelText="Facebook Page Name"
          />
          <TextField
            value={instagram}
            onChange={(e) =>
              this.updateMutableField("instagram", e.target.value)
            }
            fullWidth
            floatingLabelText="Instagram Username"
          />
          <TextField
            value={twitter}
            onChange={(e) => this.updateMutableField("twitter", e.target.value)}
            fullWidth
            floatingLabelText="Twitter Handle"
          />
          <TextField
            value={snapchat}
            onChange={(e) =>
              this.updateMutableField("snapchat", e.target.value)
            }
            fullWidth
            floatingLabelText="Snapchat Username"
          />
        </Paper>
      </div>
    );
  }

  renderMenuQRSection() {
    const { webAppUrl } = this.state.mutable;
    const { params } = this.props;
    const restaurantId = params && params.restaurantId;
    const appPreviewUrl = `https://chowreach.web.app/?restaurantId=${restaurantId}`;
    const qrUrl = webAppUrl || appPreviewUrl;
    if (!restaurantId) return "";
    return (
      <div>
        <h2>Menu QR Code</h2>
        <Paper style={{ padding: 15 }}>
          <URLQrCode url={qrUrl} label="Menu QR Code" />
        </Paper>
        <h2>Menu preview</h2>
        <Paper style={{ padding: 15 }}>
          <Iframe
            url={appPreviewUrl}
            width="337px"
            height="600px"
            id="appPreview"
            display="block"
            position="relative"
            title="App Preview"
            allowFullScreen
          />
        </Paper>
      </div>
    );
  }

  renderOnlineOrderingSection() {
    //TODO turn on with online ordering
    return <div />;
    const { params } = this.props;
    const restaurantId = params && params.restaurantId;
    const { stripe_account } = this.state;

    return (
      <div>
        <h2>Online Ordering</h2>

        <Paper style={{ padding: 15 }}>
          {stripe_account ? (
            <p>Your account is linked with Stripe</p>
          ) : (
            <LinkWithStripe restaurantId={restaurantId} />
          )}
        </Paper>
      </div>
    );
  }
}

export default StripeElements(injectStripe(Settings));



// WEBPACK FOOTER //
// ./src/pages/Settings.js